import { useSelector } from "react-redux";

import { AuthUtility } from "../helpers/AuthUtility";
import { RootState } from "../store";

import { HOSPITAL_REGISTRATION_LOCALSTORAGE_KEY } from "./constants";
import { useRegistrationContext } from "./registrationContext";
import { RegistrationForm } from "./types";

export const useHospitalRegistrationProgress = (): string => {
  const isAuthorisedUser = AuthUtility.isAuthorisedUser();
  const loginData = useSelector((state: RootState) => state.login);
  const { registrationContext } = useRegistrationContext()!;

  try {
    const formContextJson = localStorage.getItem(HOSPITAL_REGISTRATION_LOCALSTORAGE_KEY);
    const localStorageData: RegistrationForm = formContextJson ? JSON.parse(formContextJson) : {};

    const {
      emailId,
      hospitalName,
      hospitalAddress,
      hospitalCity,
      hospitalZipcode,
      hospitalPhoneNumber,
      firstName,
      lastName,
      password,
      anticipatedReliefNeed,
      isCorporateGroup,
      selfIdentifiedEnterpriseName,
    } = { ...registrationContext, ...localStorageData };

    if (isAuthorisedUser && !loginData.userId) {
      return "Loading";
    }

    // true when calendly call has been booked
    const isRegistrationComplete = !!loginData.isRegistrationComplete;

    // if registration complete, redirect to hospital page
    if (isRegistrationComplete) {
      return "/hospital";
    }

    // if account is created (and hospital is in a Roo state), they should be on book call step
    if (isAuthorisedUser) {
      const isRooState = !!(
        registrationContext?.isRooState ||
        loginData.isRooTechState ||
        loginData.isRooVetState
      );

      if (isRooState) {
        return "/register/hospitalBookCall";
      } else {
        return "/register/success";
      }
    }

    // handles redirect for steps before account is created
    const isWelcomeStepComplete = !!(
      hospitalName &&
      anticipatedReliefNeed !== undefined &&
      (!isCorporateGroup || selfIdentifiedEnterpriseName)
    );
    const isProfileStepComplete = !!(
      hospitalAddress &&
      hospitalCity &&
      hospitalZipcode &&
      hospitalPhoneNumber
    );
    const isAccountStepComplete = !!(emailId && firstName && lastName && password);

    if (!isWelcomeStepComplete) {
      return "/register";
    } else if (!isProfileStepComplete) {
      return "/register/hospitalProfile";
    } else if (!isAccountStepComplete) {
      return "/register/hospitalAccount";
    } else {
      return "/register";
    }
  } catch (e) {
    return "/register";
  }
};
